import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { GUIBox, GUITextDebug, GUISelectableText } from "./GameUIElements";
import { DialogueParser } from "../DialogueParser";
import { findDialogSpeaker, getTextOfAction } from "../../../helper/gameActionTreeHelper";
import { toHumanReadableId } from "../../../../shared/helper/actionTreeHelper";
import { gameStore } from "../../../stores/GameStore";
import { localSettingsStore } from "../../../stores/LocalSettingsStore";
import { NOTIFICATION_BORDER_WIDTH } from "./NotificationController";
import { Heading2Base } from "../../shared/Heading";
const ContentContainer = styled(GUIBox).withConfig({
  displayName: "PastNotificationsItem__ContentContainer",
  componentId: "sc-1tcl7mx-0"
})(["background-color:", ";border-color:solid ", " ", "px;color:black;margin:0.2em;"], props => props.backgroundColor, props => props.borderColor, NOTIFICATION_BORDER_WIDTH);
const Title = styled(Heading2Base).withConfig({
  displayName: "PastNotificationsItem__Title",
  componentId: "sc-1tcl7mx-1"
})([""]);
const Text = styled.div.withConfig({
  displayName: "PastNotificationsItem__Text",
  componentId: "sc-1tcl7mx-2"
})([""]);
export const PastNotificationsItem = observer(({
  info
}) => {
  const {
    t
  } = useTranslation();
  const {
    action,
    extraInformation,
    borderColor,
    backgroundColor
  } = info;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    borderColor: borderColor,
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(DialogueParser, {
    dialogueString: findDialogSpeaker(action, gameStore.gameEngine.rootActionTree, t),
    initialTreeScopeContext: action
  })), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(DialogueParser, {
    dialogueString: getTextOfAction(action, extraInformation, t),
    initialTreeScopeContext: action
  })), localSettingsStore.showDebugInfo && /*#__PURE__*/React.createElement(GUITextDebug, null, "action id:\xA0", /*#__PURE__*/React.createElement(GUISelectableText, null, toHumanReadableId(action.$modelId))));
});